export default __webpack_public_path__ + "static/media/Leggings of the Sepulcher.b0184288.jpg";